var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pega-duplicate-container row" }, [
    _c(
      "div",
      { staticClass: "column align-self-middle pega-duplicate-label" },
      [_vm._v("\n    重複応募\n  ")]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "column align-self-middle" }, [
      _vm._v("\n    （前回の応募日）\n    "),
      _c(
        "span",
        {
          staticClass: "pega-duplicate-date",
          attrs: { "data-test": "entry-date" },
        },
        [_vm._v(_vm._s(_vm._f("parseDate")(_vm.entryDate)))]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "column align-self-middle",
        attrs: { "data-test": "entry-job" },
      },
      [
        _vm._v(
          "\n    （応募した求人）求人ID：" +
            _vm._s(_vm.job.id) +
            " " +
            _vm._s(_vm.job.name) +
            "\n  "
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "column align-self-middle" },
      [
        _c(
          "router-link",
          {
            attrs: {
              to: { name: "entryDetail", params: { entryId: _vm.entryId } },
            },
          },
          [
            _c("span", { staticClass: "boss-button previous-button" }, [
              _vm._v("前回の詳細を見る"),
            ]),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }